import React from 'react';

import { useLogo } from '../../logoContext';


import lockIcon from '../../asset/images/new/lock.png'

import HeaderComponent from 'src/components/header.component';
import imageIcon from '../../asset/images/new/image.png'

import LogOutComponent from 'src/components/logout.component';


const ContactUSPage = () => {

  document.title = 'Contact Us | SNB';

  const logoSrc = useLogo();

  return (
    <div className='home-wrapper app-wrapper'>
      <div className="gradient-card">
        <div className='page-content'>

          <HeaderComponent showBack={true} />


          <div className="container custom-container-sm">
            <h1 className='mt-2 text-white' style={{ fontWeight: 'bold', marginBottom: '30px' }}>Photo Gallery</h1>

            <div className="row px-1">
              <div className="col-6 pe-2 ps-0">
                <div className="gallery-card">
                  <img src={imageIcon} alt="" />
                </div>
              </div>
              <div className="col-6 ps-2 pe-0">
                <div className="gallery-card">
                  <img src={imageIcon} alt="" />
                </div>
              </div>
              <div className="col-6 pe-2 ps-0">
                <div className="gallery-card">
                  <img src={imageIcon} alt="" />
                </div>
              </div>
              <div className="col-6 ps-2 pe-0">
                <div className="gallery-card">
                  <img src={imageIcon} alt="" />
                </div>
              </div>
              <div className="col-6 pe-2 ps-0">
                <div className="gallery-card">
                  <img src={imageIcon} alt="" />
                </div>
              </div>
              <div className="col-6 ps-2 pe-0">
                <div className="gallery-card">
                  <img src={imageIcon} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <LogOutComponent />
      </div>

    </div>
  );
};

export default ContactUSPage;

